"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchClients = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_query_1 = require("@tanstack/react-query");
var axios_1 = (0, tslib_1.__importDefault)(require("axios"));
var pipe_1 = (0, tslib_1.__importDefault)(require("lodash/fp/pipe"));
var keyBy_1 = (0, tslib_1.__importDefault)(require("lodash/fp/keyBy"));
var mapValues_1 = (0, tslib_1.__importDefault)(require("lodash/fp/mapValues"));
var FosAuthorizer_1 = require("../FosAuthorizer");
var config_1 = require("../../config");
/**
 * Call user-prefs and obtain the list of available clients for the current user
 * @return {any} - An object of available clients: { 11: "NTTest1", 14: "NTTest2" }
 *
 * Cognito jwt api response: { 11: "NTTest1", 14: "NTTest2" }
 * Okta jwt api response: [{ID: 11, DbName: "NTTest1"}, {ID: 14, DbName: "NTTest2"}]
 */
var useFetchClients = function () {
    var _a, _b;
    var ntConfig = (0, config_1.useNTConfig)();
    var callFetchClients = (0, react_1.useCallback)(function () { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
        var baseURL, jwt, userPrefsApi, response, err_1, data;
        var _a, _b;
        return (0, tslib_1.__generator)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    baseURL = (_b = (_a = ntConfig === null || ntConfig === void 0 ? void 0 : ntConfig.Rest) === null || _a === void 0 ? void 0 : _a.UserPrefApi) === null || _b === void 0 ? void 0 : _b.endpoint;
                    return [4 /*yield*/, FosAuthorizer_1.FosAuthorizer.getAuthorizationToken()];
                case 1:
                    jwt = _c.sent();
                    if (!jwt) {
                        throw new Error('Cannot call api without a valid jwt');
                    }
                    userPrefsApi = axios_1.default.create({
                        baseURL: baseURL,
                        headers: {
                            Authorization: jwt,
                        },
                    });
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, userPrefsApi.get('/names')];
                case 3:
                    response = _c.sent();
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _c.sent();
                    throw new Error('error fetching clients');
                case 5:
                    data = response.data.data;
                    if (Array.isArray(data)) {
                        return [2 /*return*/, (0, pipe_1.default)((0, keyBy_1.default)('ID'), (0, mapValues_1.default)('DbName'))(data)];
                    }
                    return [2 /*return*/, data];
            }
        });
    }); }, [(_b = (_a = ntConfig === null || ntConfig === void 0 ? void 0 : ntConfig.Rest) === null || _a === void 0 ? void 0 : _a.UserPrefApi) === null || _b === void 0 ? void 0 : _b.endpoint]);
    return (0, react_query_1.useQuery)(['FETCH_CLIENTS'], callFetchClients);
};
exports.useFetchClients = useFetchClients;
exports.default = useFetchClients;
